import axios from 'axios'

const baseURL = {
  default: process.env.VUE_APP_API_ENDPOINT,
  file_cdn: process.env.VUE_APP_IMG_API_ENDPOINT,
}

// 建立 axios 實例
const instance = axios.create()
const instanceAuth = axios.create()
const instanceFile = axios.create()

// 共用 interceptor：加上 Authorization
const addAuthInterceptor = (axiosInstance) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('authorization_token')
      if (token) {
        config.headers.Authorization = 'Bearer ' + token
      }
      return config
    },
    (error) => Promise.reject(error)
  )
}

// 加上 token 的 instance
addAuthInterceptor(instanceAuth)
addAuthInterceptor(instanceFile) // 檔案上傳也需要 token

// ======== api (不含 token) ========
const methods = {
  GET: (url, params, type) => instance({ method: 'GET', url, params, baseURL: baseURL[type] }),
  POST: (url, payloadOrParams, type) =>
    instance({
      method: 'POST',
      url,
      params: payloadOrParams.params,
      data: payloadOrParams.payload,
      baseURL: baseURL[type],
    }),
  PATCH: (url, payloadOrParams, type) =>
    instance({
      method: 'PATCH',
      url,
      params: payloadOrParams.params,
      data: payloadOrParams.payload,
      baseURL: baseURL[type],
    }),
  PUT: (url, payloadOrParams, type) =>
    instance({
      method: 'PUT',
      url,
      params: payloadOrParams.params,
      data: payloadOrParams.payload,
      baseURL: baseURL[type],
    }),
  DELETE: (url, params, type) => instance({ method: 'DELETE', url, params, baseURL: baseURL[type] }),
}
const api = (method, url, payloadOrParams = {}, type = 'default') => {
  if (!Object.hasOwn(methods, method)) {
    throw new Error(`unknown_request_method: ${method}`)
  }
  return methods[method](url, payloadOrParams, type)
}

// ======== apiAuth (帶 token) ========
const methodsAuth = {
  GET: (url, params, type) => instanceAuth({ method: 'GET', url, params, baseURL: baseURL[type] }),
  POST: (url, payloadOrParams, type) =>
    instanceAuth({
      method: 'POST',
      url,
      params: payloadOrParams.params,
      data: payloadOrParams.payload,
      baseURL: baseURL[type],
    }),
  PATCH: (url, payloadOrParams, type) =>
    instanceAuth({
      method: 'PATCH',
      url,
      params: payloadOrParams.params,
      data: payloadOrParams.payload,
      baseURL: baseURL[type],
    }),
  PUT: (url, payloadOrParams, type) =>
    instanceAuth({
      method: 'PUT',
      url,
      params: payloadOrParams.params,
      data: payloadOrParams.payload,
      baseURL: baseURL[type],
    }),
  DELETE: (url, params, type) => instanceAuth({ method: 'DELETE', url, params, baseURL: baseURL[type] }),
}
const apiAuth = (method, url, payloadOrParams = {}, type = 'default') => {
  if (!Object.hasOwn(methodsAuth, method)) {
    throw new Error(`unknown_request_method: ${method}`)
  }
  return methodsAuth[method](url, payloadOrParams, type)
}

// ======== apiFile (檔案上傳，帶 token) ========
const methodsFile = {
  POST: (url, data, type) =>
    instanceFile({
      method: 'POST',
      url,
      data,
      baseURL: baseURL[type],
      // headers: {
      //   'Content-Type': 'multipart/form-data',
      // },
    }),
  PATCH: (url, data, type) =>
    instanceFile({
      method: 'PATCH',
      url,
      data,
      baseURL: baseURL[type],
      // headers: {
      //   'Content-Type': 'multipart/form-data',
      // },
    }),
}
const apiFile = (method, url, data = {}, type = 'file_cdn') => {
  if (!Object.hasOwn(methodsFile, method)) {
    throw new Error(`unknown_request_method: ${method}`)
  }
  return methodsFile[method](url, data, type)
}

// ======== 匯出 ========
export { api, apiAuth, apiFile }
